import React, { useEffect, useState } from "react";
import { siteActiveInactive, siteDetail } from "../action";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import DetailCard from "../../../components/siteDetailCard";
import { MdVerifiedUser } from "react-icons/md";
import { RxCrossCircled } from "react-icons/rx";
import ImgSlider from "../../../components/imgSlider";
import ProperSpinner from "../../../components/spinner/ProperSpinner";
import CustomModal from "../../../components/customModal";
import ImagePreviewer from "../../../components/imgSlider/ImagePreviewer";
import {
  dateFormatter,
  getDateAndTimeFormatted,
  isImage,
  isVideo,
} from "../../../utils/commonFunctions";
import RatingsAndReviews from "./RatingsAndReviews";

/**
 * @function SideDetail
 * @description for SideDetail
 * @returns JSX for SideDetail
 */

const SideDetail = () => {
  const { siteId } = useParams();
  const dispatch = useDispatch();
  const [site, setSite] = useState({});
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selectedPostIdx, setSelectedPostIdx] = useState(0);

  const modalClose = () => {
    setModal(false);
  };

  const isActiveHandler = (id, status) => {
    if (status === 1) {
      dispatch(
        siteActiveInactive({ status: 2 }, `?siteId=${id}`, (response) => {
          setSite((prev) => ({ ...prev, status: 2 }));
        }),
      );
    } else {
      dispatch(
        siteActiveInactive({ status: 1 }, `?siteId=${id}`, (response) => {
          setSite((prev) => ({ ...prev, status: 1 }));
        }),
      );
    }
    modalClose();
  };

  const renderModalBody = (status) => {
    return (
      <div>
        <p>
          Are you sure want to{" "}
          <span className="highlight--text">
            {status == 2 ? "Activate" : "Deactivate"}
          </span>{" "}
          this site?{" "}
        </p>
      </div>
    );
  };

  useEffect(() => {
    setLoading(true);
    dispatch(
      siteDetail(`?siteId=${siteId}`, (response) => {
        setSite(response);
        setLoading(false);
      }),
    );
  }, []);

  let mediaUrls = [];
  if (site?.defaultImage) {
    mediaUrls.push(site.defaultImage);
  }
  if (site?.siteImages?.length) {
    mediaUrls = [...mediaUrls, ...site.siteImages];
  }
  const medias = [];
  mediaUrls?.forEach((media, i) => {
    if (isImage(media)) {
      medias.push({
        src: media,
        alt: `Image ${i}`,
      });
    } else if (isVideo(media)) {
      const ext = media?.split(".").pop();
      medias.push({
        type: "video",
        width: 1280,
        height: 720,
        sources: [
          {
            src: media,
            type: `video/${ext}`,
          },
        ],
      });
    }
  });

  if (loading) return <ProperSpinner />;
  return (
    <div className="site-det-wrapper">
      <div className="site-det-header-container">
        <h3 className="w-50 mb-0 text-primary">{"Site Detail"}</h3>
        {site && site.status && (
          <div
            onClick={() => setModal(true)}
            className={`site-details-btns ${site?.status === 2 ? "site-success-btn" : "site-warning-btn"}`}
          >
            {site.status === 2 ? "Activate" : "Deactivate"}
            {site?.status === 2 ? (
              <MdVerifiedUser className="lg-icon" />
            ) : (
              <RxCrossCircled className="lg-icon" />
            )}
          </div>
        )}
      </div>
      <div className="site-content-container ">
        <div className="slider-container ">
          {(site?.siteImages || site?.defaultImage) && (
            <>
              <ImgSlider
                Images={mediaUrls}
                setSelectedPostIdx={setSelectedPostIdx}
                setVisible={setVisible}
                selectedPostIdx={selectedPostIdx}
              />
              <ImagePreviewer
                medias={medias}
                visible={visible}
                setVisible={setVisible}
                selectedPostIdx={selectedPostIdx}
                setSelectedPostIdx={setSelectedPostIdx}
              />
            </>
          )}
        </div>
        <div className="site-details-main-container">
          <div className="site-info-contaianer">
            <div className="site-details-container-1 ">
              <div className="personal-info-container">
                <h4 className="label-text heading text-underline ">
                  {"Site Details"}
                </h4>
                <div className="site-data-container">
                  <DetailCard data={site.siteName} label={"Site Name"} />
                  <DetailCard data={site.description} label={"Description"} />
                  <DetailCard
                    data={site.status == 1 ? "Activate" : "Deactivate"}
                    label={"Status"}
                  />
                  <DetailCard
                    data={getDateAndTimeFormatted(site.createdAt)}
                    label={"Created At"}
                  />
                  <DetailCard
                    data={getDateAndTimeFormatted(site.updatedAt)}
                    label={"Updated At"}
                  />
                </div>
              </div>
            </div>

            <div className="site-details-container-2">
              <div className="personal-info-container">
                <h4 className="label-text heading text-underline ">
                  {"Site Address Details"}
                </h4>
                <div className="site-data-container">
                  <DetailCard
                    data={site.siteAddress?.addressLine1}
                    label={"Address 1"}
                  />
                  <DetailCard
                    data={site.siteAddress?.addressLine2}
                    label={"Address 2"}
                  />
                  <DetailCard data={site.siteAddress?.city} label={"City"} />
                  <DetailCard data={site.siteAddress?.state} label={"State"} />
                  <DetailCard
                    data={site.siteAddress?.postalCode}
                    label={"Postal Code"}
                  />
                  <DetailCard
                    data={site.siteAddress?.country}
                    label={"Country"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CustomModal
        visible={modal}
        visibleHandler={modalClose}
        heading={"Confirmation"}
        body={() => renderModalBody(site?.status)}
        confirmHandler={() =>
          // block_unblock_handler(userDetails?._id, userDetails?.status)
          isActiveHandler(site?._id, site?.status)
        }
        modalSize="small"
        confirmText={site?.status == 2 ? "Yes, Activate" : "Yes, Deactivate"}
        footershow={true}
        closeText="Cancel"
      />
      <RatingsAndReviews />
    </div>
  );
};

export default SideDetail;
